
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class OnboardingListApi extends BaseApi {
  endPoint: string = '/api/admin/onboarding-list';
}
